import { Button, Popup } from '@repo/design-system-kit';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { GenericErrorSvg } from '../../../svgs/generic-error';
import { faqService } from '../../../utils/faq-composer';
import styles from './sca.module.css';

interface GenericErrorProps {
  onClose?: () => void;
}

export function GenericError({ onClose }: GenericErrorProps): React.ReactNode {
  // NOTE -- this is needed until we have a better way to handle the portal container in qunit tests
  // https://www.notion.so/qonto/React-popover-library-used-within-react-aria-components-does-mount-popovers-modals-outside-of-qunit--12631ee4c696806e87dbef81e9a27922
  const TEST_PORTAL_CONTAINER = document.getElementById('ember-testing') ?? undefined;

  const [isOpen, setIsOpen] = useState(true);
  const { formatMessage } = useIntl();
  const handleClose = (): void => {
    onClose?.();
    setIsOpen(false);
  };

  return (
    <Popup.Root
      aria-label={formatMessage({ id: 'sca.generic-error.title' })}
      data-testid="sca-generic-error-popup"
      isOpen={isOpen}
      portalContainer={TEST_PORTAL_CONTAINER}
      role="dialog"
    >
      <Popup.CloseButton onPress={handleClose} />
      <Popup.Header>
        <figure className={styles.illustrationWrap}>
          <GenericErrorSvg height={118} width="auto" />
        </figure>
        <Popup.Title>
          <FormattedMessage id="sca.generic-error.title" />
        </Popup.Title>
      </Popup.Header>
      <Popup.Body>
        <p className="body-standard ">
          <FormattedMessage
            id="sca.generic-error.subtitle"
            values={{
              a: (chunks: React.ReactNode) => (
                <a
                  className={styles.faqLink}
                  href={faqService.getLocalizedArticle('how_to_contact_support')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </p>
      </Popup.Body>
      <Popup.Footer>
        <Button data-testid="sca-generic-error-cta" onPress={handleClose} variant="primary">
          <FormattedMessage id="sca.btn.got_it" />
        </Button>
      </Popup.Footer>
    </Popup.Root>
  );
}
